import { getProductLabel } from '../../campaign-editor/transform-for-rendering';
import withProducts from '../withProducts/with-products';

function ProductLabel({ id, products }) {
  return getProductLabel(products.find(p => p.id === id));
}

export default withProducts({})(ProductLabel);
